module.exports = __webpack_public_path__ + "static/media/Anita.00078287.jpg";